import { StyledLayout, CoreContent } from './Layout.Styled'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import ResponsiveState from './ResponsiveState/ResponsiveState'
import Secure from './Secure/Secure'
import LoginModal from '../../Home/LoginModal/LoginModal'
import CartPersisit from '../../CartPersist/CartPersist'
import ProjectListManager from '../../ProjectListManager/ProjectListManager'

const Layout = ({ children, className, hideHeader = false, authRequired = true }) => {
  return (
    <StyledLayout className={className}>
      <Secure authRequired={authRequired}>
        <CartPersisit />
        <ProjectListManager />
        <ResponsiveState />
        {!hideHeader && <Header />}
        <CoreContent hideHeader={hideHeader}>{children}</CoreContent>
        <Footer />
        <LoginModal />
      </Secure>
    </StyledLayout>
  )
}

export default Layout
